var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid pt-4"},[_c('div',{staticClass:"password-box"},[_c('PasswordUpdate',{on:{"close":_vm.goBack}})],1),_c('div',{staticClass:"back-box"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"fa-solid fa-chevron-left pr-1"}),_vm._v(" "+_vm._s(_vm.$t('general.back'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }